<template>
  <div class="factory-dashboard" ref="dashboardWrap">
    <!-- 详情弹窗页面 -->
    <div class="page page-detail">
      <header class="header-bar">
        <div class="header-left">
          <button class="back-btn" @click="goBack">
            <i class="fas fa-arrow-left"></i>
            返回总览
          </button>
          <div class="split-line"></div>
          <h2 class="detail-title">{{ currentEquip.name }} {{ currentEquip.model }}</h2>
        </div>
        <div class="header-right">
          <div class="header-date">
            <i class="fas fa-calendar-alt"></i>
            <span>{{ headerDate }}</span>
          </div>
          <div class="header-time">{{ headerTime }}</div>
          <div class="online-tag">
            <span class="sdot" :class="statusDotClass(currentEquip.state)"></span>
<!--            <span class="sdot running"></span>-->
            <span :style="statusTagStyle(currentEquip.state)">{{ currentEquip.state === 1 ? '运行中' : currentEquip.state === 0 ? '待机' : '离线' }}</span>
          </div>
        </div>
      </header>
      <main class="main-container detail-main">
        <!-- 详情左栏 -->
        <div class="detail-col-left">
          <div class="card fade-in">
            <div class="card-title">订单进度</div>
            <div class="two-col-grid">
              <div class="stat-item cyan">
                <div class="sub-tip">已完成</div>
                <div class="stat-val cyan">{{ currentEquip.completedOrders }}</div>
                <div class="sub-pct">{{ detailCompletedPct }}%</div>
              </div>
              <div class="stat-item warn">
                <div class="sub-tip">待生产</div>
                <div class="stat-val warn">{{ currentEquip.pendingOrders }}</div>
                <div class="sub-pct">{{ detailPendingPct }}%</div>
              </div>
            </div>
            <div class="center-pie-wrap">
              <RingChart
                  chartId="detailOrderRing"
                  :width="`120px`"
                  :height="'120px'"
                  :total="String(detailTotalOrder)"
                  :text="'总订单'"
                  total-top="50%"
                  total-left="50%"
                  :radius="['55%', '85%']"
                  :center="['50%', '50%']"
                  :legend-show="false"
                  :data="[
                  {name:'已完成',value:currentEquip.completedOrders},
                  {name:'待生产',value:currentEquip.pendingOrders}
                ]"
                  :color="['#00e0f0','#ffb347']"
              />
            </div>
          </div>
          <div class="card fade-in flex-col-grow">
            <div class="card-title">订单列表</div>
            <div class="detail-order-list">
              <div v-for="o in currentEquip.orders" :key="o.id" class="order-scroll-item">
                <div class="order-info">
                  <div class="order-name">{{ o.name }}</div>
                  <div class="order-sub">{{ o.id }}</div>
                </div>
                <div class="order-qty-box">
                  <div class="qty-num">{{ formatNum(o.qty) }}</div>
                  <div class="qty-tip">张</div>
                </div>
                <span class="tag" :class="orderTagClass(o.status)">{{ orderStatusText(o.status) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 详情中间主体 -->
        <div class="detail-col-center flex-col-grow">
          <div class="card fade-in">
            <div class="card-title">设备运行详情</div>
            <div class="equip-detail-top">
              <div class="detail-thumb">
                <img :src="currentEquip.image" alt="">
              </div>
              <div class="detail-info-grid">
                <div class="info-cell">
                  <span class="info-label">设备名称</span>
                  <div class="info-text">{{ currentEquip.name }}</div>
                </div>
                <div class="info-cell">
                  <span class="info-label">设备类型</span>
                  <div class="info-text">{{ currentEquip.deviceType }}</div>
                </div>
                <div class="info-cell">
                  <span class="info-label">设备型号</span>
                  <div class="info-text">{{ currentEquip.model }}</div>
                </div>
                <div class="info-cell">
                  <span class="info-label">运行状态</span>
                  <div class="info-text">
                    <span class="sdot" :class="statusDotClass(currentEquip.status)"></span>
                    {{ statusText(currentEquip.status) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 当前作业数据 -->
          <div class="card fade-in">
            <div class="card-title">当前作业数据</div>
            <div class="job-data-grid">
              <div class="job-stat-item">
                <div class="job-label">
                  <i class="fas fa-file-alt blue"></i>
                  当前作业名称
                </div>
                <div class="job-val">{{ currentEquip.currentJob || '--' }}</div>
              </div>
              <div class="job-stat-item">
                <div class="job-label ">
                  <i class="fas fa-tachometer-alt green"></i>
                  实时生产速度
                </div>
                <div class="job-val cyan">{{ currentEquip.speed > 0 ? formatNum(currentEquip.speed) : 0 }}</div>
                <div class="job-sub">张/小时</div>
              </div>
              <div class="job-stat-item">
                <div class="job-label">
                  <i class="fas fa-play-circle blue"></i>
                  作业开始时间
                </div>
                <div class="job-val blue">{{ currentEquip.jobStart || '--' }}</div>
              </div>
              <div class="job-stat-item">
                <div class="job-label">
                  <i class="fas fa-flag-checkered warn"></i>
                  预估结束时间
                </div>
                <div class="job-val warn">{{ currentEquip.jobEnd || '--' }}</div>
              </div>
              <div class="job-stat-item">
                <div class="job-label">
                  <i class="fas fa-cubes green"></i>
                  当前产量
                </div>
                <div class="job-val cyan">{{ currentEquip.currentOutput > 0 ? formatNum(currentEquip.currentOutput) : 0 }}</div>
                <div class="job-sub">张</div>
              </div>
              <div class="job-stat-item">
                <div class="job-label ">
                  <i class="fas fa-hourglass-half danger"></i>
                  待生产量
                </div>
                <div class="job-val danger">{{ currentEquip.pendingOutput > 0 ? formatNum(currentEquip.pendingOutput) : 0 }}</div>
                <div class="job-sub">张</div>
              </div>
            </div>
          </div>

          <!-- 趋势图 -->
          <div class="two-col-chart-row">
            <div class="card chart-card">
              <div class="card-title">运行速度趋势</div>
              <LineChart
                  :id="'speedLine'"
                  :height="220"
                  :data="speedLineData"
                  :smooth="true"
              />
            </div>
            <div class="card chart-card">
              <div class="card-title quality-title">
                <i class="fas fa-award"></i>
                印刷质量趋势
              </div>
              <LineChart
                  :id="'qualityLine'"
                  :height="220"
                  :data="qualityLineData"
                  :smooth="true"
                  :linecolor="['#3ee8a5']"
              />
            </div>
          </div>
        </div>

        <!-- 详情右侧 -->
        <div class="detail-col-right">
          <div class="card fade-in">
            <div class="card-title">生产印量</div>
            <div class="center-pie-wrap">
              <RingChart
                  chartId="detailPrintRing"
                  :width="`120px`"
                  :height="'120px'"
                  total-top="50%"
                  total-left="50%"
                  :radius="['55%', '85%']"
                  :center="['50%', '50%']"
                  :legend-show="false"
                  :data="[
                  {name:'有效印',value:currentEquip.okCount},
                  {name:'过版',value:currentEquip.noCount}
                ]"
                  :color="['#00e0f0','#ffb347']"
              />
            </div>
            <div class="print-data-list">
              <div class="print-row" style="justify-content: space-between;">
                <div style="display: flex;align-items: center;gap: 8px;">
                  <span class="mini-dot blue"></span>
                  <span class="print-label">今日总印量</span>
                </div>

                <span class="print-num blue">{{ formatNum(currentEquip.count) }}</span>
              </div>
              <div class="print-row">
                <span class="mini-dot cyan"></span>
                <span class="print-label">有效印量</span>
                <div class="dur-bar">
                  <div class="dur-fill cyan" :style="{width: detailValidPct + '%'}"></div>
                </div>
                <span class="print-num cyan">{{ formatNum(currentEquip.okCount) }}</span>
                <span class="print-pct cyan">{{ detailValidPct }}%</span>
              </div>
              <div class="print-row">
                <span class="mini-dot warn"></span>
                <span class="print-label">过版印量</span>
                <div class="dur-bar">
                  <div class="dur-fill warn" :style="{width: detailOverPct + '%'}"></div>
                </div>
                <span class="print-num warn">{{ formatNum(currentEquip.noCount) }}</span>
                <span class="print-pct warn">{{ detailOverPct }}%</span>
              </div>
            </div>
          </div>
          <div class="card fade-in">
            <div class="card-title">水箱状态</div>
            <div class="water-grid">
              <div class="water-item">
                <i class="fas fa-temperature-high blue"></i>
                <div class="water-val blue">{{ currentEquip.wd || '--' }}</div>
                <div class="water-tip">温度 °C</div>
              </div>
              <div class="water-item">
                <i class="fas fa-flask cyan"></i>
                <div class="water-val cyan">{{ currentEquip.ph || '--' }}</div>
                <div class="water-tip">PH值</div>
              </div>
              <div class="water-item">
                <i class="fas fa-bolt warn"></i>
                <div class="water-val warn">{{ currentEquip.ddl || '--' }}</div>
                <div class="water-tip">电导率 μS</div>
              </div>
            </div>
          </div>
          <div class="card fade-in">
            <div class="card-title">OEE指标</div>
            <div class="oee-item">
              <div class="oee-head">
                <span class="oee-label">时间稼动率</span>
                <span class="oee-num blue">{{ currentEquip.timeOee }}%</span>
              </div>
              <div class="oee-bar">
                <div class="oee-fill blue" :style="{width: currentEquip.timeOee + '%'}"></div>
              </div>
            </div>
            <div class="oee-item">
              <div class="oee-head">
                <span class="oee-label">性能稼动率</span>
                <span class="oee-num blue">{{ currentEquip.chanNengOee }}%</span>
              </div>
              <div class="oee-bar">
                <div class="oee-fill purple" :style="{width: currentEquip.chanNengOee + '%'}"></div>
              </div>
            </div>
          </div>
          <div class="card fade-in maintenance-card">
            <div class="card-title">保养项目</div>
            <!--            <div v-if="unfinishMaintenance.length === 0" class="maintenance-empty">-->
            <!--              <i class="fas fa-check-circle"></i>-->
            <!--              所有保养项目均已完成-->
            <!--            </div>-->
            <div class="maintenance-row">
              <i v-if="currentEquip.isMaintain !==1" class="fas fa-exclamation-circle mp"></i>
              <i v-else class="fas fa-check-circle"></i>
              <div class="main-text">
                <div class="main-name">日保养</div>
                <div class="main-desc mp">{{ currentEquip.isMaintain === 1 ? '保养已完成': '保养尚未完成' }}</div>
              </div>
              <span class="main-tag mp">{{ currentEquip.isMaintain === 1 ? '已处理': '待处理' }}</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import API from "@/api";
// import * as echarts from 'echarts'
import RingChart from '@/components/Charts/RingChartdevice.vue'
import LineChart from '@/components/Charts/LineChartDevice.vue'

export default {
  name: 'PrintMonitorDashboard',
  components: {
    RingChart,
    LineChart
  },
  data() {
    return {
      page: 'dashboard',
      headerDate: '',
      headerTime: '',
      totalPrintCount: 0,
      ovCompleted: 0,
      ovInProgress: 0,
      ovPending: 0,
      totalOrderCount: 0,
      avgTimeUtil: 0,
      avgPerfUtil: 0,
      allEquipList: [],
      scrollOrderList: [],
      scrollStyle: { transform: 'translateY(0px)' },
      scrollTimer: null,
      envTemp: 0,
      envHumid: 0,
      currentEquip: null,
      detailTotalOrder: 0,
      detailCompletedPct: 0,
      detailPendingPct: 0,
      detailValidPct: 0,
      detailOverPct: 0,
      workDurationData: {
        total: 0,
        work: 0,
        standby: 0,
        downtime: 0
      },
      speedLineData: {},
      qualityLineData: {}
    };
  },
  computed: {

    equipRingData() {
      return (id) => [
        { name: '有效印', value: this.allEquipList.find(e => e.id === id)?.okCount || 0 },
        { name: '过版', value: this.allEquipList.find(e => e.id === id)?.noCount || 0 }
      ];
    },
    workPct() {
      return this.workDurationData.total > 0 ? ((this.workDurationData.work / this.workDurationData.total) * 100).toFixed(1) : 0;
    },
    standbyPct() {
      return this.workDurationData.total > 0 ? ((this.workDurationData.standby / this.workDurationData.total) * 100).toFixed(1) : 0;
    },
    downPct() {
      return this.workDurationData.total > 0 ? ((this.workDurationData.downtime / this.workDurationData.total) * 100).toFixed(1) : 0;
    },
    workRingData() {
      return [
        { name: '工作时长', value: this.workDurationData.work },
        { name: '待机时长', value: this.workDurationData.standby },
        { name: '停机时长', value: this.workDurationData.downtime }
      ];
    },
  },
  mounted() {
    // this.getDeviceDetail();
    // this.updateClock();
    // setInterval(() => this.updateClock(), 1000);
    //
    // this.$nextTick(() => {
    //   this.startScroll();
    // });
    // 获取路由设备id
    this.deviceId = this.$route.query.deviceId;
    this.updateClock();
    setInterval(() => this.updateClock(), 1000);
    this.getDeviceDetail();
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer);
    if (this.scrollTimer) clearInterval(this.scrollTimer);
  },
  methods: {
    getDeviceDetail() {
      API.DaPingJiTaiXinLing({deviceId: this.deviceId}).then(res => {
        console.log(res)
        this.currentEquip = res.message.data;
        this.currentEquip.currentJob = '包装盒-红茶礼盒'
        this.currentEquip.jobStart = '08:30'
        this.currentEquip.jobEnd = '14:50'
        this.currentEquip.pendingOutput = '2670'
        this.currentEquip.image = this.$route.query.url
        // 速度趋势数据处理
        const speedSource = res.message.data.speedList.map(item => {
          const day = item.time.split('-').slice(1).join('-');
          return [day, item.speed];
        });
        // 质量趋势数据处理
        const printSource = res.message.data.printList.map(item => {
          const day = item.time.split('-').slice(1).join('-');
          return [day, item.score];
        });
        this.speedLineData = {
          source: [
            ['时间', '运行速度'],
            ...speedSource
          ],
          series: [
            { name: '运行速度', type: 'line', color: '#4d9aff' }
          ],
          yAxis: {
            type: 'value',
            axisLabel: { formatter: '{value}k' },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)',
                width: 1,
                type: 'solid'
              }
            },
          },
          tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              const name = params[0].name;
              const value = params[0].data[1];
              return `${name}<br />速度: ${value} 张/时`;
            }
          }
        }
        this.qualityLineData = {
          source: [
            ['时间', '质量得分'],
            ...printSource
          ],
          series: [
            { name: '质量得分', type: 'line', color: '#3ee8a5' }
          ],
          yAxis: {
            type: 'value',
            min: 60,
            max: 100,
            axisLabel: { formatter: '{value}分' },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)',
                width: 1,
                type: 'solid'
              }
            },
          },
          tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              const date = params[0].name;
              const speed = params[0].data[1];
              return `${date}<br />分数: ${speed} 分`;
            }
          }
        }
          this.currentEquip.completedOrders = this.$route.query.completedOrders
          this.currentEquip.pendingOrders = this.$route.query.pendingOrders
          this.detailTotalOrder = this.currentEquip.completedOrders + this.currentEquip.pendingOrders
          this.detailCompletedPct =
              this.detailTotalOrder > 0
                  ? ((this.currentEquip.completedOrders / this.detailTotalOrder) * 100).toFixed(1)
                  : 0;
          this.detailPendingPct =
              this.detailTotalOrder > 0
                  ? ((this.currentEquip.pendingOrders / this.detailTotalOrder) * 100).toFixed(1)
                  : 0;
        // 模拟订单
        this.currentEquip.orders = [
          { id: 'ORD-0115-002', name: '包装盒-红茶礼盒', status: 'inProgress', qty: 12000 },
          { id: 'ORD-0115-003', name: '宣传单-新品发布', status: 'inProgress', qty: 80000 },
          { id: 'ORD-0115-004', name: '手提袋-品牌定制', status: 'pending', qty: 3000 },
          { id: 'ORD-0115-005', name: '杂志-月刊第48期', status: 'pending', qty: 15000 },
          { id: 'ORD-0115-006', name: '名片-商务系列', status: 'pending', qty: 50000 },
          { id: 'ORD-0115-007', name: '海报-艺术展', status: 'completed', qty: 20000 },
          { id: 'ORD-0115-008', name: '折页-地产宣传', status: 'inProgress', qty: 45000 },
          { id: 'ORD-0115-009', name: '信封-企业定制', status: 'pending', qty: 8000 },
          { id: 'ORD-0115-010', name: '不干胶-标签系列', status: 'pending', qty: 100000 },
          { id: 'ORD-0115-011', name: '书籍-技术手册', status: 'completed', qty: 6000 },
          { id: 'ORD-0115-012', name: '台历-新年定制', status: 'completed', qty: 3000 },
          { id: 'ORD-0115-013', name: '瓦楞纸箱-电商', status: 'inProgress', qty: 25000 },
          { id: 'ORD-0115-014', name: '彩盒-月饼礼盒', status: 'inProgress', qty: 18000 },
          { id: 'ORD-0115-015', name: '标签-食品系列', status: 'inProgress', qty: 50000 },
          { id: 'ORD-0115-016', name: '说明书-电子配件', status: 'pending', qty: 40000 },
        ]
        // 订单占比计算
        this.detailTotalOrder = Number(this.currentEquip.completedOrders || 0) + Number(this.currentEquip.pendingOrders || 0)
        this.detailCompletedPct =
            this.detailTotalOrder > 0
                ? ((this.currentEquip.completedOrders / this.detailTotalOrder) * 100).toFixed(1)
                : 0;
        this.detailPendingPct =
            this.detailTotalOrder > 0
                ? ((this.currentEquip.pendingOrders / this.detailTotalOrder) * 100).toFixed(1)
                : 0;
        // 印量占比
        this.detailValidPct =
            this.currentEquip.count > 0
                ? ((this.currentEquip.okCount / this.currentEquip.count) * 100).toFixed(1)
                : 0;
        this.detailOverPct =
            this.currentEquip.count > 0
                ? ((this.currentEquip.noCount / this.currentEquip.count) * 100).toFixed(1)
                : 0;
      })
    },


    updateClock() {
      const now = new Date();
      this.headerDate = now.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short'
      });
      this.headerTime = now.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    startScroll() {
      const totalHeight = this.scrollOrderList.length * 62;

      this.scrollTimer = setInterval(() => {
        let y = parseFloat(this.scrollStyle.transform.replace(/[^0-9.-]/g, '') || 0);
        y -= 1;
        if (Math.abs(y) >= totalHeight) {
          y = 0;
        }
        this.scrollStyle.transform = `translateY(${y}px)`;
      }, 50);
    },


    openDetail(item) {
      API.DaPingJiTaiXinLing({deviceId: item.id}).then(res => {
        console.log(res)
        this.currentEquip = res.message.data;
        this.currentEquip.currentJob = '包装盒-红茶礼盒'
        this.currentEquip.jobStart = '08:30'
        this.currentEquip.jobEnd = '14:50'
        this.currentEquip.pendingOutput = '2670'
        console.log([...res.message.data.speedList])
        const speedSource = res.message.data.speedList.map(item => {
          // 只取日期后半段 07-01 这种，更简洁好看
          const day = item.time.split('-').slice(1).join('-');
          return [day, item.speed];
        });
        const printSource = res.message.data.printList.map(item => {
          // 只取日期后半段 07-01 这种，更简洁好看
          const day = item.time.split('-').slice(1).join('-');
          return [day, item.score];
        });
        this.speedLineData = {
          source: [
            ['时间', '运行速度'],
            ...speedSource
          ],
          series: [
            { name: '运行速度', type: 'line', color: '#4d9aff' }
          ],
          yAxis: {
            type: 'value',
            // name: '张/时',
            axisLabel: { formatter: '{value}k' },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)', // 横网格颜色
                width: 1,
                type: 'solid'
              }
            },
          },
          tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              // params[0] 就是第一条线的数据
              const name = params[0].name;
              const value = params[0].data[1];
              return `${name}<br/>速度: ${value} 张/时`;
            }
          }
        }
        this.qualityLineData = {
          source: [
            ['时间', '质量得分'],
            ...printSource
          ],
          series: [
            { name: '质量得分', type: 'line', color: '#3ee8a5' }
          ],
          yAxis: {
            type: 'value',
            // name: '分数',
            min: 60,
            max: 100,
            axisLabel: { formatter: '{value}分' },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)', // 横网格颜色
                width: 1,
                type: 'solid'
              }
            },
          },
          tooltip: {
            trigger: 'axis',
            formatter: (params) => {
              const date = params[0].name;
              const speed = params[0].data[1];
              return `${date}<br/>速度: ${speed} 张/时`;
            }
          }
        }
        this.currentEquip.completedOrders = item.completedOrders
        this.currentEquip.pendingOrders = item.pendingOrders
        this.detailTotalOrder = this.currentEquip.completedOrders + this.currentEquip.pendingOrders
        this.detailCompletedPct =
            this.detailTotalOrder > 0
                ? ((this.currentEquip.completedOrders / this.detailTotalOrder) * 100).toFixed(1)
                : 0;
        this.detailPendingPct =
            this.detailTotalOrder > 0
                ? ((this.currentEquip.pendingOrders / this.detailTotalOrder) * 100).toFixed(1)
                : 0;
        this.currentEquip.orders = [
          { id: 'ORD-0115-002', name: '包装盒-红茶礼盒', status: 'inProgress', qty: 12000 },
          { id: 'ORD-0115-003', name: '宣传单-新品发布', status: 'inProgress', qty: 80000 },
          { id: 'ORD-0115-004', name: '手提袋-品牌定制', status: 'pending', qty: 3000 },
          { id: 'ORD-0115-005', name: '杂志-月刊第48期', status: 'pending', qty: 15000 },
          { id: 'ORD-0115-006', name: '名片-商务系列', status: 'pending', qty: 50000 },
          { id: 'ORD-0115-007', name: '海报-艺术展', status: 'completed', qty: 20000 },
          { id: 'ORD-0115-008', name: '折页-地产宣传', status: 'inProgress', qty: 45000 },
          { id: 'ORD-0115-009', name: '信封-企业定制', status: 'pending', qty: 8000 },
          { id: 'ORD-0115-010', name: '不干胶-标签系列', status: 'pending', qty: 100000 },
          { id: 'ORD-0115-011', name: '书籍-技术手册', status: 'completed', qty: 6000 },
          { id: 'ORD-0115-012', name: '台历-新年定制', status: 'completed', qty: 3000 },
          { id: 'ORD-0115-013', name: '瓦楞纸箱-电商', status: 'inProgress', qty: 25000 },
          { id: 'ORD-0115-014', name: '彩盒-月饼礼盒', status: 'inProgress', qty: 18000 },
          { id: 'ORD-0115-015', name: '标签-食品系列', status: 'inProgress', qty: 50000 },
          { id: 'ORD-0115-016', name: '说明书-电子配件', status: 'pending', qty: 40000 },
        ]
        this.detailValidPct =
            this.currentEquip.count > 0
                ? ((this.currentEquip.okCount / this.currentEquip.count) * 100).toFixed(1)
                : 0;
        this.detailOverPct =
            this.currentEquip.count > 0
                ? ((this.currentEquip.noCount / this.currentEquip.count) * 100).toFixed(1)
                : 0;
        // this.unfinishMaintenance =
        //     this.currentEquip.maintenance.filter(m => m.status === 'incomplete');
      })
      this.currentEquip = this.allEquipList.find(e => e.id === item.id);
      if (!this.currentEquip) return;

      this.page = 'detail';

    },

    goBack() {
      this.currentEquip = null;
      this.$router.go(-1)
    },
    formatNum(n) {
      return String(n ?? 0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    statusText(s) {
      return s === 1 ? '运行中' : s === 0 ? '待产' : '停机';
    },

    statusDotClass(s) {
      return s === 1 ? 'running' : s === 0 ? 'waiting' : 'stopped';
    },

    statusTagStyle(s) {
      return {
        color:
            s === 1
                ? '#00e0f0'
                : s === 0
                ? '#ffb347'
                : '#ff6b7a'
      };
    },

    orderStatusText(s) {
      return s === 'completed' ? '已完成' : s === 'inProgress' ? '生产中' : '待生产';
    },

    orderTagClass(s) {
      return s === 'completed'
          ? 'tag-completed'
          : s === 'inProgress'
              ? 'tag-inProgress'
              : 'tag-pending';
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;600;700&family=Noto+Sans+SC:wght@300;400;500;700;900&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css');

:root {
  --bg: #080c16;
  --card: rgba(16, 22, 38, 0.94);
  --border: rgba(59, 139, 255, 0.14);
  --accent: #4d9aff;
  --accent2: #00e0f0;
  --warn: #ffb347;
  --danger: #ff6b7a;
  --fg: #f0f5fc;
  --muted: #94a7c8;
  --ring-bg: rgba(255, 255, 255, 0.05);
  --stat-bg: rgba(59, 139, 255, 0.07);
  --quality: #3ee8a5;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
}

body {
  font-family: 'Noto Sans SC', sans-serif;
  background: var(--bg);
  color: var(--fg);
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}

body::before {
  content: '';
  position: fixed;
  inset: 0;
  background:
      repeating-linear-gradient(
          0deg,
          transparent,
          transparent 59px,
          rgba(59, 139, 255, 0.018) 59px,
          rgba(59, 139, 255, 0.018) 60px
      ),
      repeating-linear-gradient(
          90deg,
          transparent,
          transparent 59px,
          rgba(59, 139, 255, 0.018) 59px,
          rgba(59, 139, 255, 0.018) 60px
      );
  pointer-events: none;
  z-index: 0;
}

body::after {
  content: '';
  position: fixed;
  inset: 0;
  background:
      radial-gradient(ellipse at 12% 0%, rgba(59, 139, 255, 0.08) 0%, transparent 50%),
      radial-gradient(ellipse at 88% 100%, rgba(0, 224, 240, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

.factory-dashboard {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  transition: opacity 0.4s, transform 0.4s;
}

/*.page.hidden {*/
/*  opacity: 0;*/
/*  pointer-events: none;*/
/*  transform: scale(0.97);*/
/*}*/

/*.page.visible {*/
/*  opacity: 1;*/
/*  pointer-events: auto;*/
/*  transform: scale(1);*/
/*}*/

.header-bar {
  height: 56px;
  flex-shrink: 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(
      180deg,
      rgba(16, 22, 38, 0.96) 0%,
      rgba(16, 22, 38, 0.75) 100%
  );
  border-bottom: 1px solid var(--border);
  backdrop-filter: blur(12px);
  position: relative;
}

.header-left,
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}

.logo-en {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  color: var(--accent);
  font-family: 'Rajdhani', sans-serif;
  display: block;
}

.logo-cn {
  font-size: 11px;
  color: var(--muted);
  letter-spacing: 1px;
}

.company-title {
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 3px;
  font-family: 'Noto Sans SC', sans-serif;
  background: linear-gradient(90deg, var(--accent), var(--accent2));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.company-en {
  font-size: 11px;
  color: var(--muted);
  letter-spacing: 2px;
}

.header-date,
.header-time {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--muted);
}

.header-time {
  font-family: 'Rajdhani', 'Noto Sans SC', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: var(--accent);
  min-width: 80px;
  text-align: right;
}

.online-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #00e0f0;
}

.sdot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.sdot.running {
  background: var(--accent2);
  box-shadow: 0 0 8px rgba(0, 224, 240, 0.6);
  animation: pulse 1.5s infinite;
}

.sdot.waiting {
  background: var(--warn);
  box-shadow: 0 0 8px rgba(255, 179, 71, 0.6);
  animation: pulse 2s infinite;
}

.sdot.stopped {
  background: var(--danger);
  box-shadow: 0 0 8px rgba(255, 107, 122, 0.6);
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.3);
  }
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(77, 154, 255, 0.6), transparent);
  animation: scan 6s linear infinite;
  opacity: 0.6;
}

@keyframes scan {
  0% {
    top: 0;
    opacity: 0;
  }
  10% {
    opacity: 0.6;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    top: 100%;
    opacity: 0;
  }
}

.main-container {
  flex: 1;
  display: flex;
  gap: 12px;
  padding: 12px;
  min-height: 0;
  overflow: hidden;
}

.aside-left,
.aside-right {
  width: 22%;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
}

.section-middle {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
  padding: 16px;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, transparent, var(--accent), var(--accent2), transparent);
  opacity: 0.5;
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--accent);
  letter-spacing: 2px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--border);
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.card-title::before {
  content: '';
  width: 3px;
  height: 14px;
  background: linear-gradient(180deg, var(--accent), var(--accent2));
  border-radius: 2px;
  flex-shrink: 0;
}

.quality-title {
  color: var(--quality);
}

.flex-col-grow {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.fade-in {
  animation: fadeIn 0.5s ease both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.total-print-box {
  text-align: center;
  margin-bottom: 16px;
}

.sub-tip {
  font-size: 14px;
  color: var(--muted);
  margin-bottom: 4px;
}

.big-num {
  font-family: 'Rajdhani', 'Noto Sans SC', sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: var(--accent);
  line-height: 1.1;
}

.two-col-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.stat-item {
  text-align: center;
  padding: 12px 8px;
  border-radius: 8px;
  background: var(--stat-bg);
  border: 1px solid var(--border);
}

.stat-item.cyan {
  background: rgba(0, 224, 240, 0.08);
}

.stat-item.blue {
  background: rgba(77, 154, 255, 0.08);
}

.stat-item.warn {
  background: rgba(255, 179, 71, 0.08);
}

.stat-val {
  font-family: 'Rajdhani', 'Noto Sans SC', sans-serif;
  font-size: 28px;
  font-weight: 700;
  margin-top: 4px;
}

.stat-val.cyan {
  color: var(--accent2);
}

.stat-val.blue {
  color: var(--accent);
}

.stat-val.warn {
  color: var(--warn);
}

.sub-pct {
  font-size: 13px;
  color: var(--muted);
  margin-top: 2px;
}

.ring-center-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  position: relative;
  width: 120px;
  height: 120px;
  margin-left: auto;
  margin-right: auto;
}

.ring-inner-text {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ring-num {
  font-family: 'Rajdhani', sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
}

.ring-num.blue {
  color: var(--accent);
}

.ring-num.cyan {
  color: var(--accent2);
}

.ring-num.danger {
  color: var(--danger);
}

.ring-tip {
  font-size: 12px;
  color: var(--muted);
  margin-top: 4px;
}

.duration-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dur-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background 0.2s;
}

.dur-row:hover {
  background: rgba(255, 255, 255, 0.02);
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}

.dot.cyan {
  background: var(--accent2);
}

.dot.warn {
  background: var(--warn);
}

.dot.danger {
  background: var(--danger);
}

.dur-label {
  font-size: 14px;
  min-width: 56px;
  color: #f0f5fc;
}

.dur-bar {
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: var(--ring-bg);
  overflow: hidden;
}

.dur-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 1s ease;
}

.dur-fill.cyan {
  background: var(--accent2);
}

.dur-fill.warn {
  background: var(--warn);
}

.dur-fill.danger {
  background: var(--danger);
}

.dur-h {
  font-family: 'Rajdhani', sans-serif;
  font-size: 14px;
  font-weight: 600;
  min-width: 36px;
  text-align: right;
}

.dur-h.cyan {
  color: var(--accent2);
}

.dur-h.warn {
  color: var(--warn);
}

.dur-h.danger {
  color: var(--danger);
}

.dur-pct {
  font-size: 13px;
  color: var(--muted);
  min-width: 38px;
  text-align: right;
}

.env-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  flex: 1;
  min-height: 0;
}

.env-ring-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 8px;
  border-radius: 10px;
  background: var(--stat-bg);
  border: 1px solid var(--border);
}

.svg-ring {
  position: relative;
  width: 100px;
  height: 100px;

}

.svg-ring svg {
  width: 100%;
  height: 100%;
}

.env-label {
  font-size: 13px;
  color: var(--muted);
  margin-top: 8px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
}

.equip-grid {
  display: grid;
  gap: 12px;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.equip-card {
  cursor: pointer;
  transition: transform 0.22s, box-shadow 0.22s, border-color 0.22s;
  border: 1px solid var(--border);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  padding: 10px;
}

.equip-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 28px rgba(77, 154, 255, 0.18);
  border-color: rgba(77, 154, 255, 0.4);
}
.equip-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, transparent, var(--accent), var(--accent2), transparent);
  opacity: .5;
}

.equip-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.equip-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.equip-name {
  font-weight: 700;
  font-size: 15px;
  color: #f0f5fc;
}

.status-tag {
  font-size: 13px;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
  white-space: nowrap;
}

.equip-thumb {
  width: 100%;
  aspect-ratio: 8/5;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--border);
  flex-shrink: 0;
  position: relative;
  margin-bottom: 12px;
}

.equip-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.equip-card:hover .equip-thumb img {
  transform: scale(1.06);
}

.equip-thumb::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 30%, rgba(8, 12, 22, 0.5) 100%);
  pointer-events: none;
}

.equip-pie-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.pie-wrap {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}

.pie-wrap canvas {
  width: 120px !important;
  height: 120px !important;
}

.pie-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.pie-val {
  font-family: 'Rajdhani', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: var(--accent);
  line-height: 1;
}

.pie-lbl {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.pie-data-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
}

.data-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 6px;
}
.data-row .title {
  color: #f0f5fc;
}
.data-row.cyan-bg {
  background: rgba(0, 224, 240, 0.06);
}

.data-row.warn-bg {
  background: rgba(255, 179, 71, 0.06);
}

.data-row-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.mini-dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.mini-dot.cyan {
  background: var(--accent2);
}

.mini-dot.blue {
  background: var(--accent);
}

.mini-dot.warn {
  background: var(--warn);
}

.data-num {
  font-family: 'Rajdhani', sans-serif;
  font-weight: 600;
}

.data-num.cyan {
  color: var(--accent2);
}

.data-num.warn {
  color: var(--warn);
}

.order-stat-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.stat-mini {
  text-align: center;
  padding: 6px 4px;
  border-radius: 6px;
  background: var(--stat-bg);
}

.stat-mini-tip {
  font-size: 12px;
  color: var(--muted);
  margin-bottom: 2px;
}

.stat-mini-val {
  font-family: 'Rajdhani', sans-serif;
  font-size: 15px;
  font-weight: 700;
}

.stat-mini-val.cyan {
  color: var(--accent2);
}

.stat-mini-val.warn {
  color: var(--warn);
}

.order-overview-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.overview-pie-wrap {
  position: relative;
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}

.overview-pie-wrap canvas {
  width: 120px !important;
  height: 120px !important;
}

.overview-stat-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
}

.ov-stat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 8px;
}

.ov-stat.cyan-bg {
  background: rgba(0, 224, 240, 0.07);
}

.ov-stat.blue-bg {
  background: rgba(77, 154, 255, 0.07);
}

.ov-stat.warn-bg {
  background: rgba(255, 179, 71, 0.07);
}

.ov-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f0f5fc;
}

.ov-num {
  font-family: 'Rajdhani', sans-serif;
  font-size: 16px;
  font-weight: 700;
}

.ov-num.cyan {
  color: var(--accent2);
}

.ov-num.blue {
  color: var(--accent);
}

.ov-num.warn {
  color: var(--warn);
}

.order-scroll-card {
  min-height: 0;
}

.scroll-container {
  overflow: hidden;
  position: relative;
  flex: 1;
  min-height: 0;
}

.scroll-inner {
  animation: none;
}

.order-scroll-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
  gap: 8px;
}

.order-scroll-item:hover {
  background: rgba(77, 154, 255, 0.04);
}

.order-info {
  flex: 1;
  min-width: 0;
}

.order-name {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #f0f5fc;
}

.order-sub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.order-qty-box {
  text-align: right;
  flex-shrink: 0;
  min-width: 60px;
}

.qty-num {
  font-family: 'Rajdhani', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--accent);
}

.qty-tip {
  font-size: 12px;
  color: var(--muted);
}

.tag {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 5px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.tag-completed {
  background: rgba(0, 224, 240, 0.14);
  color: var(--accent2);
}

.tag-inProgress {
  background: rgba(77, 154, 255, 0.14);
  color: var(--accent);
}

.tag-pending {
  background: rgba(255, 179, 71, 0.14);
  color: var(--warn);
}

.scroll-tip {
  margin-left: auto;
  font-size: 13px;
  font-weight: normal;
  color: var(--muted);
  letter-spacing: 0;
}

/* 详情页 */
.page-detail {
  background: var(--bg);
}

.back-btn {
  background: rgba(77, 154, 255, 0.12);
  border: 1px solid rgba(77, 154, 255, 0.3);
  color: var(--accent);
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.back-btn:hover {
  background: rgba(77, 154, 255, 0.22);
  border-color: var(--accent);
}

.split-line {
  width: 1px;
  height: 20px;
  background: var(--border);
}

.detail-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--accent);
}

.detail-main {
  overflow: hidden;
}

.detail-col-left,
.detail-col-right {
  width: 22%;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
  min-height: 0;
  overflow-y: auto;
}

.detail-col-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  min-height: 0;
}

.center-pie-wrap {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  position: relative;
  width: 120px;
  height: 120px;
  margin-left: auto;
  margin-right: auto;
}

.center-pie-wrap canvas {
  width: 120px !important;
  height: 120px !important;
}

.detail-order-list {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.equip-detail-top {
  display: flex;
  gap: 16px;
}

.detail-thumb {
  width: 200px;
  height: 125px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border);
  flex-shrink: 0;
}

.detail-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-info-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  font-size: 14px;
}

.info-cell {
  padding: 10px 12px;
  border-radius: 8px;
  background: var(--stat-bg);
}

.info-label {
  font-size: 13px;
  color: var(--muted);
}

.info-text {
  margin-top: 4px;
  font-weight: 700;
  font-size: 16px;
  color: #f0f5fc;
}

.job-data-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.job-stat-item {
  padding: 12px 14px;
  border-radius: 10px;
  background: var(--stat-bg);
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.job-label {
  font-size: 13px;
  color: var(--muted);
  display: flex;
  align-items: center;
  gap: 6px;
}

.job-label i {
  /*color: var(--accent);*/
  font-size: 14px;
}
.fa-flag-checkered.blue {
  color: var(--accent);
}

.fa-flag-checkered.warn {
  color: var(--warn);
}

.fa-hourglass-half.danger {
  color: var(--danger);
}

.fa-play-circle.blue {
  color: var(--accent);
}
.fa-file-alt.blue{
  color: var(--accent);
}
.fa-tachometer-alt.green{
  color: var(--accent2);;
}
.fa-cubes.green{
  color: var(--accent2);;
}
.job-val {
  font-family: 'Rajdhani', 'Noto Sans SC', sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.15;
  color: #f0f5fc;
}

.job-val.cyan {
  color: var(--accent2);
}

.job-val.blue {
  color: var(--accent);
}

.job-val.warn {
  color: var(--warn);
}

.job-val.danger {
  color: var(--danger);
}

.job-sub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.two-col-chart-row {
  display: flex;
  gap: 12px;
  flex: 1;
  min-height: 0;
}

.chart-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.chart-card canvas {
  flex: 1;
  min-height: 0;
}

.print-data-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
}

.print-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background 0.2s;
}

.print-row:hover {
  background: rgba(255, 255, 255, 0.02);
}

.print-label {
  font-size: 14px;
  color: #f0f5fc;
}

.print-num {
  font-family: 'Rajdhani', sans-serif;
  font-size: 14px;
  font-weight: 600;
  min-width: 44px;
  text-align: right;
}

.print-num.blue {
  color: var(--accent);
}

.print-num.cyan {
  color: var(--accent2);
}

.print-num.warn {
  color: var(--warn);
}

.print-pct {
  font-family: 'Rajdhani', sans-serif;
  font-size: 13px;
  font-weight: 600;
  min-width: 44px;
  text-align: right;
}

.print-pct.cyan {
  color: var(--accent2);
}

.print-pct.warn {
  color: var(--warn);
}

.water-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.water-grid .fa-temperature-high.blue {
  color: var(--accent);
}
.water-grid .fa-flask.cyan {
  color: var(--accent2);
}
.water-grid .fa-bolt.warn {
  color: var(--warn);
}
.water-item {
  text-align: center;
  padding: 8px 6px;
  border-radius: 8px;
  background: var(--stat-bg);
  border: 1px solid var(--border);
}

.water-item i {
  font-size: 14px;
}

.water-val {
  font-family: 'Rajdhani', sans-serif;
  font-size: 22px;
  font-weight: 700;
  margin: 4px 0 2px;
}

.water-val.blue {
  color: var(--accent);
}

.water-val.cyan {
  color: var(--accent2);
}

.water-val.warn {
  color: var(--warn);
}

.water-tip {
  font-size: 12px;
  color: var(--muted);
}

.oee-item {
  margin-bottom: 12px;
}

.oee-item:last-child {
  margin-bottom: 0;
}

.oee-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.oee-label {
  font-size: 14px;
  color: var(--muted);
}

.oee-num {
  font-family: 'Rajdhani', sans-serif;
  font-size: 18px;
  font-weight: 700;
}

.oee-num.blue {
  color: var(--accent);
}

.oee-bar {
  height: 8px;
  border-radius: 4px;
  background: var(--ring-bg);
  overflow: hidden;
}

.oee-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 1s ease;
}

.oee-fill.blue {
  background: linear-gradient(90deg, var(--accent2), var(--accent));
}

.oee-fill.purple {
  background: linear-gradient(90deg, var(--accent), #8b6aff);
}

.maintenance-card {
  flex-shrink: 0;
}

.maintenance-empty {
  text-align: center;
  padding: 12px;
  color: var(--muted);
  font-size: 14px;
}

.maintenance-empty i {
  color: var(--accent2);
  margin-right: 6px;
}

.maintenance-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(255, 179, 71, 0.07);
  border: 1px solid rgba(255, 179, 71, 0.14);
  transition: background 0.2s;
}

.maintenance-row:hover {
  background: rgba(255, 179, 71, 0.12);
}

.mp {
  color: var(--warn);
}

.main-text {
  flex: 1;
}

.main-name {
  font-size: 14px;
  font-weight: 500;
  color: #f0f5fc;
}

.main-desc {
  font-size: 13px;
  margin-top: 2px;
}

.main-tag {
  font-size: 14px;
  font-weight: 600;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(77, 154, 255, 0.18);
  border-radius: 2px;
}

/* 响应适配 */
@media screen and (max-width: 1200px) {
  .aside-left,
  .aside-right {
    width: 24%;
  }

  .equip-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  .job-data-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .two-col-chart-row {
    flex-direction: column;
  }
}

@media screen and (max-width: 768px) {
  .header-bar {
    padding: 0 12px;
  }

  .header-center {
    display: none;
  }

  .main-container {
    flex-direction: column;
    overflow-y: auto;
  }

  .aside-left,
  .aside-right,
  .section-middle {
    width: 100%;
    min-width: 0;
  }

  .equip-grid {
    grid-template-columns: 1fr !important;
  }

  .job-data-grid {
    grid-template-columns: 1fr;
  }

  .equip-detail-top {
    flex-direction: column;
  }

  .detail-thumb {
    width: 100%;
    height: auto;
    aspect-ratio: 16/10;
  }

  .detail-info-grid {
    grid-template-columns: 1fr;
  }
}
</style>
<style lang="scss" scoped>
.svg-ring {
  position: relative;
  width: 100px;
  height: 100px;

  // 环形进度外层容器
  ::v-deep .el-progress {
    width: 100%;
    height: 100%;
  }
  // 隐藏组件自带文字
  ::v-deep .el-progress__text {
    display: none !important;
  }
  // 插槽自定义文字绝对居中
  ::v-deep .el-progress-circle {
    position: relative;
  }
  ::v-deep .progress-inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .ring-num {
    font-family: 'Rajdhani', sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.1;
  }
  .ring-num.danger {
    color: #ff6b7a;
  }
  .ring-num.blue {
    color: #4d9aff;
  }
  .ring-tip {
    font-size: 12px;
    color: #94a7c8;
    margin-top: 4px;
  }
}
.svg-ring .progress-inner {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
</style>
